import Vue from 'vue'
import axios from 'axios'
import router from '../router'
import NutUI from '@nutui/nutui';
import '@nutui/nutui/dist/nutui.css';

// axios.defaults.baseURL = 'https://api-dev.lejian.net'
// http request 拦截器
axios.interceptors.request.use(
  config => {
    config.headers = {
      'Content-Type': 'application/json',
      'access-token':'',
      'Authorization':'',
      'Accept-Language':'zh-CN'
    }
    let tokenId = sessionStorage.getItem("TOKEN")

    if (tokenId) {
      config.headers['access-token']=tokenId;
      config.headers['Authorization']='JWT '+tokenId;
    }
    return config
  },
  err => {
    return Promise.reject(err)
  })

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    console.log(error.response)
    if (error.response.data.return_msg == undefined) {
      NutUI.Toast.text(error.response.data.detail)
    } else {
      NutUI.Toast.text(error.response.data.return_msg)
    }
    if(error.response.data.data == undefined){
       if(error.response.status == 401){
         console.log('errrrrrrrr')
        sessionStorage.clear();
        window.location = '/';
      }else{
        Message({
          message: error.response.data.return_msg,
          type: 'error',
          center:true
        })
      }
      
    }else{
      Message({
        message: error.response.data.data.gender[0],
        type: 'error',
        center:true
      })
    }
    return Promise.reject(error)
  })


// WEBPACK FOOTER //
// ./src/utils/http.js